// Sell Intelligence Constants

export const SELL_INTELLIGENCE_API_BASE = "/sapna/v1/sell-intelligence";
export const SMART_SELL_INSIGHTS_API_BASE = "/sapna/v1/smart-sell";

// Redux Action Types
export const SELL_INTELLIGENCE_CONFIGURATIONS = "SELL_INTELLIGENCE_CONFIGURATIONS";
export const SELL_INTELLIGENCE_CONFIGURATIONS_LOADING =
  "SELL_INTELLIGENCE_CONFIGURATIONS_LOADING";
export const SELL_INTELLIGENCE_LOCALITY_SERVICES =
  "SELL_INTELLIGENCE_LOCALITY_SERVICES";
export const SELL_INTELLIGENCE_INSIGHTS = "SELL_INTELLIGENCE_INSIGHTS";
export const SELL_INTELLIGENCE_INSIGHTS_LOADING =
  "SELL_INTELLIGENCE_INSIGHTS_LOADING";
export const SELL_INTELLIGENCE_COMMENTS = "SELL_INTELLIGENCE_COMMENTS";
export const SELL_INTELLIGENCE_COMMENTS_LOADING =
  "SELL_INTELLIGENCE_COMMENTS_LOADING";
export const SELL_INTELLIGENCE_ACKNOWLEDGEMENT = "SELL_INTELLIGENCE_ACKNOWLEDGEMENT";
export const SELL_INTELLIGENCE_SAVE_CONFIG_SUCCESS =
  "SELL_INTELLIGENCE_SAVE_CONFIG_SUCCESS";
export const SELL_INTELLIGENCE_SAVE_COMMENT_SUCCESS =
  "SELL_INTELLIGENCE_SAVE_COMMENT_SUCCESS";
export const SELL_INTELLIGENCE_SUMMARY = "SELL_INTELLIGENCE_SUMMARY";
export const SELL_INTELLIGENCE_SUMMARY_LOADING = "SELL_INTELLIGENCE_SUMMARY_LOADING";
export const SELL_INTELLIGENCE_RESET = "SELL_INTELLIGENCE_RESET";

// Configuration source types
export const CONFIG_SOURCE = {
  LISTING: "LISTING",
  MANUAL: "MANUAL",
};

// Service types (replaces PROPERTY_TYPE)
export const SERVICE_TYPE = {
  RENT: "rent",
  BUY: "buy",
  PG: "pg",
};

// Legacy property types for backward compatibility
export const PROPERTY_TYPE = {
  RESALE: "buy", // Maps to buy
  RENT: "rent",
  PG: "pg",
};

// Demand levels
export const DEMAND_LEVEL = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
};

// Pricing status
export const PRICING_STATUS = {
  FIT: "FIT",
  OVERPRICED: "OVERPRICED",
  UNDERPRICED: "UNDERPRICED",
  INSUFFICIENT_DATA: "INSUFFICIENT_DATA",
};

// Intelligence bucket types
export const BUCKET_TYPE = {
  AREA_INSIGHT: "AREA_INSIGHT",
  CONFIGURATION_FIT: "CONFIGURATION_FIT",
  DECISION_LAYER: "DECISION_LAYER",
};

// Service names mapping (updated field names)
export const SERVICE_NAMES = {
  fieldAssist: "Field Visit Assistance",
  photoshoot: "Professional Photoshoot of Property",
  rmAvailable: "Relationship Manager Assistance",
  audienceMaximizer: "Social Media Marketing",
  report: "Shorts",
};

// Maximum manual configurations allowed
export const MAX_MANUAL_CONFIGURATIONS = 5;

// Configuration options for dropdowns
export const CONFIGURATION_OPTIONS = [
  { value: "1 BHK", label: "1 BHK" },
  { value: "2 BHK", label: "2 BHK" },
  { value: "3 BHK", label: "3 BHK" },
  { value: "4 BHK", label: "4 BHK" },
  { value: "5 BHK", label: "5 BHK" },
  { value: "5 BHK+", label: "5 BHK+" },
];

// Service type options for dropdowns
export const SERVICE_TYPE_OPTIONS = [
  { value: SERVICE_TYPE.BUY, label: "BUY" },
  { value: SERVICE_TYPE.RENT, label: "RENT" },
  { value: SERVICE_TYPE.PG, label: "PG" },
];

// Bucket descriptions
export const BUCKET_DESCRIPTIONS = {
  AREA_INSIGHT: "Locality + Type",
  CONFIGURATION_FIT: "Locality + Type + Config",
  DECISION_LAYER: "Locality + Type + Config + Price(±20%)",
};

// Recommendation codes
export const RECOMMENDATION_CODES = {
  HIGH_DEMAND_GOOD_PRICE: "HIGH_DEMAND_GOOD_PRICE",
  HIGH_DEMAND_OVERPRICED: "HIGH_DEMAND_OVERPRICED",
  MEDIUM_DEMAND_GOOD_PRICE: "MEDIUM_DEMAND_GOOD_PRICE",
  MEDIUM_DEMAND_OVERPRICED: "MEDIUM_DEMAND_OVERPRICED",
  LOW_DEMAND_GOOD_PRICE: "LOW_DEMAND_GOOD_PRICE",
  LOW_DEMAND_OVERPRICED: "LOW_DEMAND_OVERPRICED",
  INSUFFICIENT_DATA: "INSUFFICIENT_DATA",
  OPS_NOT_AVAILABLE: "OPS_NOT_AVAILABLE",
};

export const COMMENT_MAX_LENGTH = 500;

export default {
  SELL_INTELLIGENCE_API_BASE,
  SMART_SELL_INSIGHTS_API_BASE,
  SELL_INTELLIGENCE_CONFIGURATIONS,
  SELL_INTELLIGENCE_CONFIGURATIONS_LOADING,
  SELL_INTELLIGENCE_LOCALITY_SERVICES,
  SELL_INTELLIGENCE_INSIGHTS,
  SELL_INTELLIGENCE_INSIGHTS_LOADING,
  SELL_INTELLIGENCE_COMMENTS,
  SELL_INTELLIGENCE_COMMENTS_LOADING,
  SELL_INTELLIGENCE_ACKNOWLEDGEMENT,
  SELL_INTELLIGENCE_SAVE_CONFIG_SUCCESS,
  SELL_INTELLIGENCE_SAVE_COMMENT_SUCCESS,
  SELL_INTELLIGENCE_SUMMARY,
  SELL_INTELLIGENCE_SUMMARY_LOADING,
  SELL_INTELLIGENCE_RESET,
  CONFIG_SOURCE,
  SERVICE_TYPE,
  PROPERTY_TYPE,
  DEMAND_LEVEL,
  PRICING_STATUS,
  BUCKET_TYPE,
  SERVICE_NAMES,
  MAX_MANUAL_CONFIGURATIONS,
  CONFIGURATION_OPTIONS,
  SERVICE_TYPE_OPTIONS,
  BUCKET_DESCRIPTIONS,
  RECOMMENDATION_CODES,
};
